module.exports = __webpack_public_path__ + "img/isalogo_notext.2192f807.png";